// Qué conexiones son de una fila de «Canales por agente», y cuáles no.
//
// La pantalla asigna un agente por fila, y una fila puede ser un canal entero o
// un número concreto de ese canal. Confundirlos tiene una consecuencia muy
// concreta: asignar el agente del canal borraba el de cada número, en silencio.

import type { AgentConnection } from '@/types/agent'

/** El número que reclama una conexión, o cadena vacía si no reclama ninguno. */
export function connectionNumber(connection: Pick<AgentConnection, 'config'>): string {
  const config = connection.config as Record<string, unknown> | null | undefined
  return String(config?.phone_number_id ?? '').trim()
}

export function normalizeSourceKey(value: string | null | undefined): string {
  return String(value ?? '').trim().toLowerCase()
}

/**
 * La clave con la que se indexa una fila: el canal, y el número si lo hay.
 *
 * Sin el número, dos filas del mismo canal serían la misma y se pisarían.
 */
export function rowKey(sourceKey: string, phoneNumberId?: string): string {
  const base = normalizeSourceKey(sourceKey)
  return phoneNumberId ? `${base}#${phoneNumberId}` : base
}

/**
 * Si esta conexión ocupa el sitio de esta fila, y por tanto hay que retirarla
 * antes de poner otra.
 *
 * La fila de un número solo reclama ese número; la del canal, solo las que no
 * reclaman ninguno.
 */
export function connectionBelongsToRow(
  connection: Pick<AgentConnection, 'source_key' | 'config'>,
  sourceKey: string,
  phoneNumberId?: string,
): boolean {
  if (normalizeSourceKey(connection.source_key) !== normalizeSourceKey(sourceKey)) return false
  return connectionNumber(connection) === String(phoneNumberId ?? '').trim()
}
